import { createTheme } from "@mui/material/styles";
import colors from "./colors";
import { dt } from "./redesignTokens";

const theme = createTheme({
  typography: {
    fontFamily: 'var(--font-sans)',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
            width: 8,
            height: 8,
            backgroundColor: colors.secondary.gray90,
            boxShadow: `inset 0 0 4px ${colors.secondary.gray80}`
          },
          "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
            borderRadius: 2,
            backgroundColor: colors.secondary.gray70,
            border: `1px solid ${colors.secondary.gray80}`
          },
          "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
            backgroundColor: colors.secondary.gray40
          },
          "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
            backgroundColor: colors.secondary.gray40
          },
          "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
            backgroundColor: colors.secondary.gray40
          },
          "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
            backgroundColor: colors.secondary.gray70
          }
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: colors.secondary.gray80,
          "&:hover": {
            backgroundColor: "transparent"
          },
          "&.Mui-checked": {
            color: dt.blue
          },
          "&.Mui-disabled": {
            color: colors.secondary.gray70,
            "& svg rect": {
              fill: colors.secondary.gray90,
              stroke: colors.secondary.gray40
            },
            "&.Mui-checked svg rect": {
              fill: colors.secondary.gray70,
              stroke: colors.secondary.gray70
            },
            "&.Mui-checked svg path": {
              stroke: colors.secondary.gray98
            }
          }
        }
      }
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          background: "#fff",
          borderBottom: "1px solid #d5d6d9"
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          ".MuiDialogContent-root": {
            padding: "0 24px 20px",
            "&::-webkit-scrollbar": {
              display: "none"
            }
          },

          ".MuiDialogTitle-root": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center"
          },

          ".MuiPaper-root": {
            display: "flex",
            justifyContent: "center"
          }
        }
      }
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          fontSize: 14,
          fontWeight: 600,
          "&.Mui-active": {
            color: dt.blue,
            fontWeight: 600,
          }
        },
      }
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: colors.secondary.gray20
        }
      }
    },
    MuiStepConnector: {
      styleOverrides: {
        horizontal: {
          minWidth: "32px"
        }
      }
    }
  }
});

export default theme;